import { type Group, type GroupOwner } from "../interfaces";

export function mergeOwners(groups: Group[], owners: GroupOwner[]) {
  return groups.map((x: Group) => {
    return { ...x, owners: [owners[x.id]], isLoadingOwner: false };
  });
}
